import { memo, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import styles from "./Products.module.css";

const ProductCard = ({ product }) => {
  const { t } = useTranslation();

  const cardRef = useRef(null);
  const imgRef = useRef(null);

  useEffect(function () {
    const card = cardRef.current;
    const image = imgRef.current;

    if (!card) {
      return;
    }

    const handleMouseMove = function (event) {
      const cardBounds = card.getBoundingClientRect();

      const xPosition =
        (event.clientX -
          (cardBounds.left + cardBounds.width / 2)) /
        25;

      const yPosition =
        (event.clientY -
          (cardBounds.top + cardBounds.height / 2)) /
        25;

      if (image) {
        image.style.transform =
          "translate(" +
          xPosition +
          "px, " +
          yPosition +
          "px) scale(1.05)";
      }
    };

    const handleMouseLeave = function () {
      if (image) {
        image.style.transform = "translate(0, 0) scale(1)";
      }
    };

    card.addEventListener("mousemove", handleMouseMove);
    card.addEventListener("mouseleave", handleMouseLeave);

    return function () {
      card.removeEventListener("mousemove", handleMouseMove);
      card.removeEventListener("mouseleave", handleMouseLeave);
    };
  }, []);

  return (
    <Link to={`/products/${product.id}`} className="text-decoration-none text-white d-block">
      <div ref={cardRef} className={styles.productCard}>
        <div className={styles.imageWrapper}>
          <img
            ref={imgRef}
            src={product.cover_image}
            alt={product.title}
            className={styles.productImg}
          />

          <div className={styles.overlay} />

          <div className={styles.tagsGroup}>
            {product.category && (
              <span className={styles.tag}>
                {product.category.name}
              </span>
            )}

            {product.is_featured && (
              <span className={`${styles.tag} ${styles.tagStatus}`}>
                {t("products.featured", "Featured")}
              </span>
            )}
          </div>
        </div>

        <div className={styles.details}>
          <h3 className={styles.title}>{product.title}</h3>
        </div>
      </div>
    </Link>
  );
};

export default memo(ProductCard);